<template>
  <div class="developAIModel" :class="{lan_En : lan != 'zh'}">
    <div class="pagecont1">
      <div class="title"><p>{{ $t('developAIModel.title') }}</p></div>
      <div class="bg1"><img src="../../assets/aipro/aibg2.png" alt=""></div>
      <div class="pagecont">
        <div class="cont_left">
          <div class="list">
            <div class="listInfo delay100 animateHide" v-animate="{delay: 100, class:'fadeInUp'}">
              <div class="cont_title mb20">{{ $t('developAIModel.title1') }}</div>
              <div class="cont_title mb20">{{ $t('developAIModel.title2') }}</div>
              <div class="width550 cont_desc ml20 mb20">{{ $t('developAIModel.text2_1') }} <a class="nav1" href="https://deepbrainchain.github.io/DBC-Wiki/dbc-aipublicchain/docker_build.html" target="_blank">{{ $t('developAIModel.text2_1_1') }}</a></div>
              <div class="width550 cont_desc ml20 mb20">{{ $t('developAIModel.text2_2') }}</div>
              <div class="width550 cont_desc ml20 mb20">{{ $t('developAIModel.text2_3') }} <a class="nav1" href="https://github.com/DeepBrainChain/AIComputingNode/blob/main/docs/model_api.md" target="_blank">{{ $t('developAIModel.text2_3_1') }}</a></div>
              <div class="width550 cont_desc ml20 mb20">{{ $t('developAIModel.text2_4') }}</div>
              <div class="width550 cont_desc ml20 mb20">{{ $t('developAIModel.text2_5') }}</div>
            </div>
          </div>
          <div class="cont_intro">
            <div class="block_text1">{{ $t('developAIModel.block_text1') }}</div>
            <div class="block_text1">{{ $t('developAIModel.block_text2') }}</div>
            <div class="block_text1">{{ $t('developAIModel.block_text3') }}</div>
            <div class="block_text1">{{ $t('developAIModel.block_text4') }}</div>
            <div class="block_text2">{{ $t('developAIModel.block_text5') }}</div>
            <div class="block_text3">{{ $t('developAIModel.block_text6') }}</div>
          </div>
        </div>
        <div class="cont_right">
          <div class="bg">
            <img src="../../assets/aipro/aibg5.png" alt="">
          </div>
          <img class="cont_img delay100 animateHide" v-animate="{delay: 100, class:'amplify'}" src="../../assets/aipro/ai_img7.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch, onMounted  } from "vue";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'developAIModel',
    setup() {
      const store = useStore()
      let lan = computed(() =>  store.state.lan)
      watch(lan, (newvlaue, oldvalue) => {
        console.log(newvlaue, oldvalue, 'ssss');
      })
      onMounted(() => {

      });
      return {
        lan,
      };
    }
  })
</script>

<style lang="scss" scoped>
.developAIModel {
  margin: auto;
  font-style: normal;
  width: 100%;
  overflow: hidden;
  position: relative;
  .cont_title {
    color: #fff;
    font-size: 32px;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 20px;
    letter-spacing: 1.6px;
  }
  .cont_desc {
    font-size: 16px;
    line-height: 24px; 
    letter-spacing: 1px;
    color: rgba(255, 255, 255, .6);
  }
  .pagecont1 {
    position: relative;
    width: 100%;
    margin: auto;
    max-width: 1200px;
    padding: 80px 0 100px;
    box-sizing: border-box;    
    .bg1 {
      position: absolute;
      top: -200px;
      left: -100px;
      margin: auto;
      width: 700px;
      height: 700px;
      img {
        width: 700px;
        height: 700px;
      }
    }
    .title {
      position: relative;
      z-index: 2;
      font-size: 48px;
      font-weight: 600;
      p {
        display: inline-block;
        color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(90deg, #03FFF0 30%, #6409F7 70%);
      }
    }
    .pagecont {
      position: relative;
      z-index: 2;
      display: flex;
      text-align: left;
      justify-content: space-between;
      .cont_left {
        position: relative;
        z-index: 3;
        width: 760px;
        display: flex;
        margin-top: 60px;
        flex-direction: column;
        .list {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .listInfo {
            width: 100%;
            margin-bottom: 40px;
            box-sizing: border-box;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .mb20 {
            margin-bottom: 20px;
          }
          .ml20 {
            margin-left: 20px;
          }
          a {
            color: rgba(255, 255, 255, .6);
          }
          .width550 {
            width: 550px;
          }
          .text1 {
            color: #9DFFD4;
            .nav1 {
              color: #9DFFD4;
            }
          }
        }
        .cont_intro {
          width: 550px;
          display: flex;
          padding: 50px 0;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          border-radius: 50px;
          background: rgba(255, 255, 255, .05);
          .block_text1 {
            color: #fff;
            font-size: 16px;
            border-radius: 9px;
            padding: 10px 15px;
            margin: 0 10px 10px;
            background: rgba(255, 255, 255, .1);
          }
          .block_text2 {
            color: #fff;
            width: 400px;
            padding: 10px;
            margin-top: 10px;
            text-align: center;
            border-radius: 10px;
            box-sizing: border-box;
            background: linear-gradient(270deg, #03FFF0 33%, #6409F7 100%);
          }
          .block_text3 {
            width: 100%;
            color: #fff;
            font-size: 20px;
            font-weight: 600;
            margin-top: 20px;
            text-align: center;
          }
        }
      }
      .cont_right {
        position: relative;
        width: 460px;
        display: flex;
        flex-direction: column;
        .bg {
          position: absolute;
          right: -300px;
          top: -180px;
          width: 1054px;
          z-index: 1;
          img {
            width: 1054px;
          }
        }
        .cont_img {
          margin-left: -100px;
          margin-top: -200px;
          width: 1054px;
        }
      }
    }
    
  }
}
</style>
